enum FormatoImpressaoRotulo {
    Paisagem = 0,
    Retrato = 1,
    PaisagemInvertido = 2,
    RetratoInvertido = 3,
    Vertical = 4,
    VerticalInvertido = 5,
}

export default FormatoImpressaoRotulo;
